<template>
  <button
    class="mb-2 flex w-full text-left"
    @click="toggleProduct"
  >
    <img
      :src="product.images?.[0]?.derivatives?.jpgSm?.url"
      alt="Imagen producto"
      class="mr-2 size-10 rounded object-cover"
    />
    <div class="flex flex-col">
      <span class="line-clamp-1">{{ product.name }}</span>
      <span>SKU: {{ product.sku }}</span>
    </div>
    <ChevronDownIcon
      :class="['ml-2 transition-transform', isProductExpanded ? 'rotate-180' : '']"
      class="size-5"
    />
  </button>
  <div
    v-show="isProductExpanded"
    class="mb-4 px-4 md:px-6"
  >
    <template v-if="isLoadingConstrains">
      <div class="py-4 text-center text-gray-400">Cargando restricciones...</div>
    </template>
    <template v-else>
      <maker-destination-constrain-table :destination-constrains="productConstrains || []" />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import destinationConstrainsApi from 'api/destination-constrains';
import MakerDestinationConstrainTable from './maker-destination-constrains-table.vue';
import { ChevronDownIcon } from '@heroicons/vue/24/outline';
import { useQuery } from 'vue-query';

const props = defineProps<{ product: Product }>();

const isProductExpanded = ref(false);

function toggleProduct() {
  isProductExpanded.value = !isProductExpanded.value;
}

const { data: productConstrains, isLoading: isLoadingConstrains } = useQuery(
  ['productConstrains', props.product.id],
  () => destinationConstrainsApi.productConstrains(props.product.id),
  {
    enabled: computed(() => isProductExpanded.value),
    select: (response) => response.data.destinationConstrains as DestinationConstrain[],
  },
);
</script>
